import { ofType } from 'redux-observable';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { ADD_CUSTOMER_NAMES_REQUEST, EPIC_ERROR } from 'Constants/redux';
import service from 'Api/service';
import { addCustomerNamesSuccess } from 'Actions';

const AddCustomerNamesEpic = (action$) =>
  action$.pipe(
    ofType(ADD_CUSTOMER_NAMES_REQUEST),
    debounceTime(500),
    switchMap(({ link }) =>
      from(service.get(`${import.meta.env.VITE_API_DOMAIN}${link}`)).pipe(
        map((response) => addCustomerNamesSuccess(response)),
        catchError((error) => {
          console.error('AddCustomerNamesEpic error', error);
          return of({ type: EPIC_ERROR });
        })
      )
    )
  );

export default AddCustomerNamesEpic;
